<template>
  <div class="pb-3" >
    <va-card :title="$t(`raffles.prizes.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Prêmio" v-slot="{ errors }">
                <va-input
                  v-model="prize.name"
                  class="mt-2"
                  :label="$t('raffles.prizes.forms.prizeLabel')"
                  :placeholder="$t('raffles.prizes.forms.prizePlaceholder')"
                  :success="errors.length == 0 && prize.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Descrição do Prêmio" v-slot="{ errors }">
                <p>{{$t('raffles.prizes.forms.descriptionLabel')}}</p>
                <ckeditor :editor="editor" id='editor' v-model="prize.description" :config="editorConfig"></ckeditor>
                <ErrorMessages :errors='errors'/>
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../../utils/ErrorMessages'
import Editor from 'ckeditor5-custom-build/build/ckeditor.js'
import '../../posts/ckeditor.css'
import gql from 'graphql-tag'
export default {
  name: 'PrizesAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
    raffleId: {
      required: true,
    },
  },
  data () {
    return {
      prize: {
        prize: '',
        description: '',
        datetime: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'htmlEmbed',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
          ],
        },
        language: 'pt-br',
        image: {
          toolbar: [
            'imageTextAlternative',
            'toggleImageCaption',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
          ],
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
          ],
        },
      },
    }
  },
  created () {
    this.prize.name = ''
    this.prize.description = ''
    if (this.updateData !== null) {
      this.prize_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.prize_get(this.updateData)
      } else {
        this.prize.name = ''
        this.prize.description = ''
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    prize_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          this.prize[value] = data[value]
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, description } = this.prize
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String, $description: String, $raffleId: Int!, $id: Int!) {
                  update_prize_by_pk(pk_columns: {id: $id}, _set: {name: $name, description: $description, raffle_id: $raffleId}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $description: String, $raffleId: Int!) {
                  insert_prize(objects: {name: $name, description: $description, raffle_id: $raffleId}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            description,
            raffleId: this.raffleId,
            id: this.prize.id,
          } : {
            name,
            description,
            raffleId: this.raffleId,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.prize.name = ''
          self.prize.description = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.prize.name = ''
          self.prize.description = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
